<template>
	<div class="container-fluid">
		<div class="row">
			<div class="offset-xl-3 col-xl-6 offset-md-2 col-md-8 account">
				<div class="row header">
					<div class="col-12">
						<h1>My Account</h1>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<hr>
					</div>
				</div>
				<Form v-if="account" :account="account" @upgrade="upgradeOpen = true" @cancel="cancelOpen = true"/>
			</div>
		</div>
		<Upgrade v-if="upgradeOpen" @close="upgradeOpen = false"/>
		<Cancel v-if="cancelOpen" @close="cancelOpen = false"/>
	</div>
</template>

<script>
import Form from '../Account/Form'
import Upgrade from '../Account/Upgrade.vue'
import Cancel from '../Account/Cancel.vue'

export default {
	components: {
		Form,
		Upgrade,
		Cancel
	},
	data() {
		return {
			account: null,
			upgradeOpen: false,
			cancelOpen: false
		}
	},
	mounted() {
		this.$store.commit('app/setLoading', true)

		this.$store.dispatch('account/get')
		.then((account) => {
			this.$store.commit('app/setLoading', false)
			this.account = account
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false)
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">
@import "../../scss/variables.scss";

.account {
	hr {
		border-top: 1px solid #D8D8D8;
		width: 100%;
	}

	.header {
		h1 {
			font-size: 28px;
		}
	}
	h2 {
		color: #8E8E8E;
		margin-bottom: 30px;
	}

	.save-account {
		margin-bottom: 80px;
		background-color: $brand-color;
	}
	.subscription-container {
		margin-bottom: 25px;
		.trial {
			font-weight: bold;
			padding-top: 20px;
			padding-bottom: 15px;
			background-color: white;
			width: 100%;
			margin-bottom: 30px;
			span {
				position: relative;
			}
			i {
				top: -10px;
				left: -40px;
				position: absolute;
				font-size: 24px;
				margin-right: 20px;
				color: red;
			}
			span.days-left {
				color: red;
			}
		}
		.subscription {
			margin-right: 0px;
			margin-left: 0px;
			background-color: white;
			padding-bottom: 10px;
			.update-subscription {
				div {
					padding: 25px;
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/Account.vue